import DateInput from "@/components/Common/DateInput/DateInput.vue";
import TimeInput from "@/components/Common/TimeInput/TimeInput.vue";

export default {
  components: { DateInput, TimeInput },
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    stateItems: [
      { id: "", title: "Keine Angabe" },
      { id: "open", title: "Geöffnet" },
      { id: "closed", title: "Geschlossen" },
      { id: "partiallyOpen", title: "Teilweise geöffnet" },
      { id: "openingHours", title: "Gemäß Öffnungszeiten" }
    ],
    difficultyItems: [
      { id: "easy", title: "Leicht" },
      { id: "intermediate", title: "Mittel" },
      { id: "hard", title: "Schwer" }
    ],
    trackTypeItems: [
      { id: "classic", title: "Klassisch" },
      { id: "skating", title: "Skating" },
      { id: "classicAndSkating", title: "Klassisch/Skating" }
    ],
    floodLightItems: [
      { id: "mo", title: "Montag" },
      { id: "tu", title: "Dienstag" },
      { id: "we", title: "Mittwoch" },
      { id: "th", title: "Donnerstag" },
      { id: "fr", title: "Freitag" },
      { id: "sa", title: "Samstag" },
      { id: "su", title: "Sonntag" }
    ],
    conditonItems: [
      { id: "veryGood", title: "Sehr gut" },
      { id: "good", title: "Gut" },
      { id: "okay", title: "Befriedigend" },
      { id: "bad", title: "Schlecht" }
    ]
  }),
  inject: ["sharedState"],
  mounted() {
    this.sharedState.stateItems = this.stateItems;
  }
};
